import { Component, Prop, h, Listen } from '@stencil/core';

@Component({
  tag: 'mama-expert-detail',
})
export class MamaExpertDetail {
  @Prop() hasImage: boolean = true;
  @Prop() isSingleView: boolean = false;

  @Prop() uid: string;

  @Listen('click')
  openModal(event) {
    if (!this.uid) {
      return;
    }
    if (event.target.classList.contains('show-more')) {
      const detail = document.createElement('mama-contact-detail');
      Object.assign(detail, { uid: this.uid });

      document.body.appendChild(detail);
    }
  }

  render() {
    return [
      <div class={this.hasImage ? 'expert-detail' : 'expert-detail no-image-detail'} itemscope itemtype="https://schema.org/Person">
        <slot name="image" />
        {!this.hasImage && (
          <div class="no-image">
            <svg class="user-md-solid">
              <use xlinkHref="#user-md-solid"></use>
            </svg>
          </div>
        )}
        <div class="header-details">
          <slot name="details" />
        </div>
      </div>,
      <div class={this.isSingleView ? 'hidden' : ''}>
        <slot name="button" />
      </div>,
    ];
  }
}
